import { useState, useEffect } from "react";
import { useGetMaintenanceQuery } from "store/api";
import {
  getLocalStorageItem,
  removeLocalStorageItem,
} from "utils/helpers/localStorage";

const useMaintenance = () => {
  const [isInMaintenance, setIsInMaintenance] = useState<boolean>(
    getLocalStorageItem("isInMaintenanceOpened") !== null
      ? getLocalStorageItem("isInMaintenanceOpened") === "false"
      : false
  );
  const { data: MaintenanceData = {} } = useGetMaintenanceQuery({});

  useEffect(() => {
    if (
      MaintenanceData?.isInMaintenance &&
      !getLocalStorageItem("isInMaintenanceOpened")
    ) {
      setIsInMaintenance(MaintenanceData.isInMaintenance);
    }
  }, [MaintenanceData]);

  useEffect(() => {
    const navEntries = performance.getEntriesByType(
      "navigation"
    ) as PerformanceNavigationTiming[];

    const navType = navEntries.length > 0 ? navEntries[0].type : null;

    if (navType === "reload") {
      removeLocalStorageItem("isInMaintenanceOpened");
    }
  }, []);

  useEffect(() => {
    if (isInMaintenance) {
      const handleBeforeUnload = () => {
        setIsInMaintenance(true);
      };

      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [isInMaintenance]);

  return { isInMaintenance, setIsInMaintenance };
};

export default useMaintenance;